import { Line } from "rc-progress";

const ProgressBarRenderDefault = (props: any) => {
  const { data } = props;

  if (
    !data?.CompetitionTypePrefix?.includes("XC") &&
    (data?.CompetitionTypePrefix?.includes("DC") ||
      data?.CompetitionTypePrefix?.includes("LS") ||
      data?.CompetitionTypePrefix?.includes("FC") ||
      !data?.FormattedMaxTickets)
  ) {
    return null;
  }

  if (data?.CompetitionTypePrefix?.includes("XC") && !data?.FormattedTicketsSoldPercent) {
    return null;
  }

  return (
    <div className="flex flex-col items-center w-full pt-2 pb-4 lg:pt-4 lg:pb-3 font-roboto">
      <div className="flex justify-between w-full items-center mb-1 lg:mb-2">
        {data?.HasInstantWin ? (
          <>
            <div className={"text-[10px] font-semibold leading-3 text-primary lg:text-sm lg:leading-5"}>
              {data?.FormattedTicketsSold} Won
            </div>
            <div>
              {/*lightning icon*/}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                className={"size-3 lg:size-5"}>
                <path
                  d="M8.90243 4.57347C8.87131 4.51019 8.80718 4.46988 8.73668 4.46894L6.48012 4.44063L7.50874 0.737782C7.53321 0.650032 7.49102 0.557407 7.40871 0.518313C7.32659 0.479032 7.22806 0.504626 7.17527 0.578969L3.11271 6.29772C3.07212 6.35491 3.06687 6.43 3.09902 6.49225C3.13127 6.55459 3.19549 6.59378 3.26562 6.59378H5.01227L3.58634 11.2578C3.55971 11.3449 3.59965 11.4387 3.68093 11.4798C3.70793 11.4935 3.73699 11.5001 3.76559 11.5001C3.82315 11.5001 3.87949 11.4736 3.91596 11.4247L8.88471 4.76847C8.92681 4.71213 8.93365 4.63666 8.90243 4.57347Z"
                  fill="#FF8200"
                />
              </svg>
            </div>
            <div className={"text-[10px] font-medium leading-3 text-gray-5 lg:text-sm lg:leading-5"}>
              {data?.FormattedTicketsLeft} Left
            </div>
          </>
        ) : (
          <>
            <div className={"text-[10px] font-semibold leading-3 text-primary lg:text-sm lg:leading-5"}>
              {data?.CompetitionTypePrefix?.includes("XC") ? (
                <>Sold {data?.FormattedTicketsSoldPercent}</>
              ) : (
                <>{data?.FormattedTicketsSoldPercent} sold</>
              )}
            </div>
            {data?.FormattedTicketsSold !== null && !data?.CompetitionTypePrefix?.includes("XC") && (
              <div className="flex items-center">
                {/*ticket icon*/}
                <div className={"mr-0.5"}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    className={"size-3 lg:size-5"}>
                    <path
                      d="M19 8.12234V4.66634C19 3.92967 18.4033 3.33301 17.6666 3.33301H2.99996C2.26329 3.33301 1.66663 3.92967 1.66663 4.66634V8.12234C2.44196 8.39767 2.99996 9.13034 2.99996 9.99967C2.99996 10.869 2.44196 11.6017 1.66663 11.877V15.333C1.66663 16.0697 2.26329 16.6663 2.99996 16.6663H17.6666C18.4033 16.6663 19 16.0697 19 15.333V11.877C18.2246 11.6017 17.6666 10.869 17.6666 9.99967C17.6666 9.13034 18.2246 8.39767 19 8.12234ZM14.0346 9.30701L12.1 10.747L12.8186 13.049C12.9153 13.3577 12.5646 13.6123 12.3006 13.425L10.3333 12.0303L8.36596 13.425C8.10196 13.6123 7.75196 13.3577 7.84796 13.049L8.56663 10.747L6.63196 9.30701C6.37263 9.11434 6.50663 8.70234 6.82996 8.69834L9.24129 8.67034L10.0133 6.38567C10.1166 6.07967 10.55 6.07967 10.6533 6.38567L11.4253 8.67034L13.8366 8.69834C14.16 8.70167 14.294 9.11368 14.0346 9.30701Z"
                      fill="#898994"
                    />
                  </svg>
                </div>
                <div className={"inline-flex items-center"}>
                  <span className="text-[10px] font-medium leading-3 text-gray-5 lg:text-sm lg:leading-5 uppercase">
                    {data?.FormattedTicketsSold}
                  </span>
                  <span className={"text-gray-5 text-[10px] font-medium leading-3 lg:text-sm lg:leading-5 px-1"}>
                    {" "}
                    /{" "}
                  </span>
                  <span className={"text-[10px] font-medium leading-3 text-primary lg:text-sm lg:leading-5 uppercase"}>
                    {data?.FormattedMaxTickets}
                  </span>
                </div>
              </div>
            )}
          </>
        )}
      </div>
      <Line
        percent={Number(data?.TicketsSoldPercent === null ? 0 : data?.TicketsSoldPercent)}
        strokeWidth={2}
        strokeColor="#FF8200"
        trailWidth={2}
        className="h-1 lg:h-1.5 w-full rounded-full first-of-type:[&>path]:stroke-black/8"
      />
    </div>
  );
};

export default ProgressBarRenderDefault;
